import { useContext } from 'react';
import { sum, filter } from 'lodash';
import { DateTime } from 'luxon';
import Link from 'next/link';
import {
    calculateTotalCount
} from './utils';
import { toMoney, toPercent } from './filters';
import WidgetContext from './WidgetContext';

export default function Cart({ showAllArticles=true, label='Warenkorb', showArticleCount=true, showTicketing=false }) {
    const { contingents, setContingents, ticketing } = useContext(WidgetContext);
    
    function decreaseContingent(contingent) {
        Object.assign(contingent, {count: Math.max(0, contingent.count - 1)});
        if (contingent.count == 0) {
            let addons = filter(contingents, addon => addon.addon && addon.contingent_id === contingent.id);
            for (let addon of addons) {
                addon.count = 0;
            }
        }
        setContingents([...contingents]);
    }
    
    function increaseContingent(contingent) {
        Object.assign(contingent, {count: Math.max(0, contingent.count + 1)});
        setContingents([...contingents]);
    }

    function decreaseAddon(addon, contingent) {
        Object.assign(addon, {contingent_id: null, count: Math.max(0, addon.count - 1)});
        setContingents([...contingents]);
    }
    
    function increaseAddon(addon, contingent) {
        Object.assign(addon, {contingent_id: contingent.id, count: Math.max(0, addon.count + 1)});
        setContingents([...contingents]);
    }

    function setPriceGross(contingent, price_gross) {
        Object.assign(contingent, {price_gross: Math.min(Math.max(contingent.pay_as_you_want_min, price_gross), contingent.pay_as_you_want_max)});
        setContingents([...contingents]);
    }

    let totalCount = calculateTotalCount(contingents);
    let articles = contingents;
    if (!showAllArticles) {
        articles = filter(contingents, contingent => !!contingent.count);
    }

    // Filter out addons
    articles = filter(contingents, contingent => !contingent.addon);

    let addons = filter(contingents, contingent => contingent.addon);

    let articlesView = null;
    if (!articles.length) {
        articlesView = (<div className="mt-8">Derzeit sind leider keine Tickets verfügbar.</div>);
    } else {
        articlesView = articles.map((contingent, ix) => (
            <div className="border-b border-b-blue-medium">
              <div key={contingent.id} className="flex flex-col lg:flex-row items-start lg:items-center justify-between py-5 ">
                {contingent.picture ? (
                    <div className="w-20 mr-3 h-24 bg-center bg-contain bg-no-repeat" style={{backgroundImage: `url(${contingent.picture})`}}>
                    </div>
                ): null}
                <div className="flex-1">
                  <div className="text-lg font-bold mb-1">{contingent.name}</div>
                  {contingent.type === 'pay_as_you_want' ? (
                      <p>
                        {toMoney(contingent.pay_as_you_want_min)} - {toMoney(contingent.pay_as_you_want_max)}
                        <div className="font-normal mb-1 leading-[12px] text-[9px]">
                          inkl. {toPercent(contingent.vat_rate)} MwSt.
                        </div>
                      </p>
                  ) : (
                      <p>
                        {toMoney(contingent.price_gross)}
                        <div className="font-normal mb-1 leading-[12px] text-[9px]">
                          inkl. {toPercent(contingent.vat_rate)} MwSt.
                        </div>
                      </p>
                  )}
                  {contingent.is_invite_only && <p className="text-red-500">Nur mit Code verfügbar</p>}
                  <p className="text-sm pr-2">{contingent.description}</p>
                </div>
                <div className="flex w-full lg:w-auto pt-4 lg:pt-0 justify-between">
                  <div className="flex flex-row w-28 justify-between items-center">
                    <button onClick={() => decreaseContingent(contingent)} className="z-10 bg-gold text-white rounded-full w-9 h-9 flex items-center justify-center font-bold text-lg pb-1 pl-0.5">-</button>
                    <div className="-mx-3 flex-1 flex items-center justify-center bg-light_brown h-9">{contingent.count}</div>
                    <button onClick={() => increaseContingent(contingent)} className="bg-gold text-white rounded-full w-9 h-9 flex items-center justify-center font-bold text-lg pb-1 pl-0.5">+</button>
                  </div>
                  {contingent.type === 'pay_as_you_want' ? (
                      <div className="font-bold flex flex-col items-end text-lg pl-6 lg:min-w-[145px]">
                        <div>
                          <input
                            className="w-24 border font-bold rounded-full px-1 text-right"
                            type="number"
                            value={contingent.price_gross}
                            onChange={event => setPriceGross(contingent, parseFloat(event.target.value))}
                            required={true}
                          /> €
                        </div>
                      </div>
                  ) : (
                      <div className="font-bold flex items-center text-lg pl-6 justify-end lg:min-w-[145px]">
                        {toMoney(contingent.count * contingent.price_gross)}
                      </div>
                  )}
                </div>
              </div>
              {
                  (addons && contingent.has_addons) ?
                      addons.map(addon => (
                          <div className="flex max-w-[80%] md:max-w-full justify-end mb-2">
                            {!addon.count ? (
                                <button onClick={() => increaseAddon(addon, contingent)} className={`flex items-center ${!contingent.count || addon.count ? 'bg-gray-dark opacity-30' : 'bg-gold'} text-white rounded-xl p-1 px-2 cursor-pointer`}>
                                  <span className="font-bold text-lg pb-[1px]">+&nbsp;</span>
                                  {addon.name} hinzufügen&nbsp;
                                  {toMoney(addon.price_gross)}

                                </button>
                            ): (
                                addon.contingent_id === contingent.id ? (
                                    <>
                                      <button onClick={() => decreaseAddon(addon, contingent)} className={`flex items-center ${!contingent.count ? 'bg-gray-dark opacity-30' : 'bg-gold'} text-white rounded-xl p-1 px-2 cursor-pointer`}>
                                        <span className="font-bold text-lg pb-[1px]">-&nbsp;</span>
                                        {addon.name} entfernen
                                      </button>
                                      <div className="font-bold flex items-center text-lg pl-6 justify-end lg:min-w-[145px]">
                                        {toMoney(addon.count * addon.price_gross)}
                                      </div>
                                    </>
                                ) : (
                                    <div className="h-[41px]">
                                      {addon.name} bereits hinzugefügt
                                    </div>
                                )
                            )}
                          </div>
                      )) : null
              }
            </div>
        ));
    }

    return (
        <div>
          {showTicketing ? (
              (
                  <>
                    <div className="flex flex-row justify-between">
                      <h2 className="text-mm lg:text-xl font-bold">{ticketing?.subevent?.event?.title}</h2>
                      <Link href={`/theater-details/${ticketing.subevent.event.slug}`}>
                        <a className="underline">Infos zum Stück</a>
                      </Link>
                    </div>
                    <div className="flex flex-row justify-between">
                      {/* ticketing?.start_time && (
                          <h3 className="font-bold text-lg">{DateTime.fromISO(ticketing?.start_time).setLocale('de').toFormat("ccc'.' dd.MM. HH:mm 'Uhr'")}</h3>) */}
                      <Link href={`/theater-details/${ticketing.subevent.event.slug}#tickets`}>
                        <a className="underline">Weitere Termine</a>
                      </Link>
                    </div>
                  </>
              )
          ) : (
              <h2 className="text-xl font-bold">{label}</h2>
          )}
          {showArticleCount && <div>{totalCount} Artikel im Warenkorb</div>}
          <div>
            {articlesView}
          </div>
        </div>
    );
}
